import Alpine from "alpinejs";
import focus from "@alpinejs/focus";
import intersect from "@alpinejs/intersect";

// @ts-ignore
import autoanimate from "@marcreichel/alpine-auto-animate";

import { initBundleBuilderComponent } from "./bundle-builder";
import { initSubmarineComponent } from "./submarine";
import { initCartStore } from "./cart";
import { showConfetti } from "./confetti";

declare global {
  interface Window {
    Alpine: typeof Alpine;
  }
}

window.Alpine = Alpine;

Alpine.plugin(focus);
Alpine.plugin(intersect);
Alpine.plugin(autoanimate);

initCartStore();
initBundleBuilderComponent();
initSubmarineComponent();

Alpine.directive("money", (el, { expression }, { evaluateLater, effect }) => {
  const getPrice = evaluateLater<number>(expression);

  effect(() => {
    getPrice((price) => {
      if (price === undefined || price === null) {
        return null;
      }

      el.textContent = new Intl.NumberFormat("en-AU", {
        style: "currency",
        currency: "AUD",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(Math.floor((price / 100) * 100) / 100);
    });
  });
});

Alpine.magic("showConfetti", () => (el: HTMLElement) => showConfetti(el));

Alpine.start();
